var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-tick-green"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick-green",
    clipPath: "url(#clip-tick-green)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33897",
    "data-name": "Group 33897",
    transform: "translate(0 -0.322)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29764",
    "data-name": "Rectangle 29764",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(0 0.322)",
    fill: "#4ab37b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33616",
    "data-name": "Path 33616",
    d: "M100.863,56.989h0a.308.308,0,0,1-.237-.108L99,55.117a.32.32,0,1,1,.473-.43l1.4,1.517,3.872-3.861a.312.312,0,0,1,.452,0,.321.321,0,0,1,0,.452l-4.109,4.1A.293.293,0,0,1,100.863,56.989Z",
    transform: "translate(-94.104 -46.295)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen);
export default __webpack_public_path__ + "static/media/tick-green.e9a546ee858e7b027a9de6445a291ccd.svg";
export { ForwardRef as ReactComponent };